import { getStoreKey } from "src/config/app-config";
import type { StoreKey } from "src/lib/Intl";

export const ORDER_NUMBER_PATTERN = /^[A-Z]{3}-\d+$/;

const FALLBACK_PREFIX = "COM";

export const orderNumberPrefixByStoreKey: Record<StoreKey, string> = {
  "OT-COM": "COM",
  "OT-NL": "ONL",
  "OT-BE": "OBE",
  "OT-DE": "ODE",
  "OT-FR": "OFR",
  "OT-UK": "OUK",
  "OT-ES": "OES",
  "OT-IT": "OIT",
  "OT-US": "OUS",
  "pl-PL": "OPL",
  "OT-ZZ": FALLBACK_PREFIX,
  "": FALLBACK_PREFIX,
};

export function getOrderNumberPlaceholder(
  storeKey: StoreKey = getStoreKey()
): string {
  return `${orderNumberPrefixByStoreKey[storeKey] || FALLBACK_PREFIX}-142876`;
}

// Lifts a recognisable order number out of whatever was typed or pasted
// (surrounding text, dash variants, stray spaces, a zero typed for the prefix
// O), so the format nudge only shows when nothing salvageable is there.
export function normalizeOrderNumber(value: string): string {
  const cleaned = value.toUpperCase().replace(/[\u2010-\u2015\u2212]/g, "-");
  const match = cleaned.match(/(?:^|[^A-Z0])([A-Z0]{3})\s*-?\s*(\d+)/);

  return match ? `${match[1].replace(/0/g, "O")}-${match[2]}` : value.trim();
}
